import { CalgaryConsent } from "./CalgaryConsent";
import { CalgaryAssent } from "./CalgaryAssent";
import { WinnipegConsent } from "./WinnipegConsent";
import { WinnipegAssent } from "./WinnipegAssent";
import { EdmontonConsent } from "./EdmontonConsent";
import { EdmontonAssent } from "./EdmontonAssent";
import { OttawaConsent } from "./OttawaConsent";
import { OttawaAssent } from "./OttawaAssent";
import { MontrealConsent } from "./MontrealConsent";
import { MontrealAssent } from "./MontrealAssent";
import { QuebecCityConsent } from "./QuebecCityConsent";
import { QuebecCityAssent } from "./QuebecCityAssent";
import { VancouverConsent } from "./VancouverConsent";
import { VancouverAssent } from "./VancouverAssent";
import { KelownaConsent } from "./KelownaConsent";
import { KelownaAssent } from "./KelownaAssent";
import { LondonConsent } from "./LondonConsent";
import { LondonAssent } from "./LondonAssent";
import { SiksikaMarchMadnessAssent } from "./SiksikaMarchMadnessAssent";
import { SiksikaMarchMadnessConsent } from "./SiksikaMarchMadnessConsent";

export const consentForms = {
  Calgary: CalgaryConsent,
  Winnipeg: WinnipegConsent,
  Edmonton: EdmontonConsent,
  Ottawa: OttawaConsent,
  Montreal: MontrealConsent,
  Quebec: QuebecCityConsent,
  Vancouver: VancouverConsent,
  Kelowna: KelownaConsent,
  London: LondonConsent,
  Whistler_Crankworx: CalgaryConsent,
  Siksika_March_Madness: SiksikaMarchMadnessConsent,
  University_of_Calgary: CalgaryConsent,
  Universite_Laval: QuebecCityConsent
};

export const assentForms = {
  Calgary: CalgaryAssent,
  Winnipeg: WinnipegAssent,
  Edmonton: EdmontonAssent,
  Ottawa: OttawaAssent,
  Montreal: MontrealAssent,
  Quebec: QuebecCityAssent,
  Vancouver: VancouverAssent,
  Kelowna: KelownaAssent,
  London: LondonAssent,
  Whistler_Crankworx: CalgaryAssent,
  Siksika_March_Madness: SiksikaMarchMadnessAssent,
  University_of_Calgary: CalgaryAssent,
  Universite_Laval: QuebecCityAssent
};

export const consentContentRequired = {
  Calgary: true,
  Winnipeg: true,
  Edmonton: true,
  Ottawa: false,
  Montreal: true,
  Quebec: true,
  Vancouver: true,
  Kelowna: true,
  London: true,
  Whistler_Crankworx: true,
  Siksika_March_Madness: true,
  University_of_Calgary: true,
  Universite_Laval: true
};

export const assentContentRequired = {
  Calgary: true,
  Winnipeg: true,
  Edmonton: false,
  Ottawa: false,
  Montreal: true,
  Quebec: true,
  Vancouver: false,
  Kelowna: false,
  London: true,
  Whistler_Crankworx: true,
  Siksika_March_Madness: true,
  University_of_Calgary: true,
  Universite_Laval: true
};
